(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire3c76"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire3c76"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dlJNO", function(module, exports) {
$parcel$export(module.exports, "loadStripe", function () { return (parcelRequire("7Hbcq")).loadStripe; });
parcelRequire("7Hbcq");

});
parcelRegister("7Hbcq", function(module, exports) {

$parcel$export(module.exports, "loadStripe", function () { return $c55f0f00c083b958$export$de80f7562c3fd6b1; });
var $c55f0f00c083b958$var$V3_URL = "https://js.stripe.com/v3";
var $c55f0f00c083b958$var$V3_URL_REGEX = /^https:\/\/js\.stripe\.com\/v3\/?(\?.*)?$/;
var $c55f0f00c083b958$var$EXISTING_SCRIPT_MESSAGE = "loadStripe.setLoadParameters was called but an existing Stripe.js script already exists in the document; existing script parameters will be used";
var $c55f0f00c083b958$var$findScript = function findScript() {
    var scripts = document.querySelectorAll('script[src^="'.concat($c55f0f00c083b958$var$V3_URL, '"]'));
    for(var i = 0; i < scripts.length; i++){
        var script = scripts[i];
        if (!$c55f0f00c083b958$var$V3_URL_REGEX.test(script.src)) continue;
        return script;
    }
    return null;
};
var $c55f0f00c083b958$var$injectScript = function injectScript(params) {
    var queryString = params && !params.advancedFraudSignals ? "?advancedFraudSignals=false" : "";
    var script = document.createElement("script");
    script.src = "".concat($c55f0f00c083b958$var$V3_URL).concat(queryString);
    var headOrBody = document.head || document.body;
    if (!headOrBody) throw new Error("Expected document.body not to be null. Stripe.js requires a <body> element.");
    headOrBody.appendChild(script);
    return script;
};
var $c55f0f00c083b958$var$registerWrapper = function registerWrapper(stripe, startTime) {
    if (!stripe || !stripe._registerWrapper) return;
    stripe._registerWrapper({
        name: "stripe-js",
        version: "3.3.0",
        startTime: startTime
    });
};
var $c55f0f00c083b958$var$stripePromise = null;
var $c55f0f00c083b958$var$onErrorListener = null;
var $c55f0f00c083b958$var$onLoadListener = null;
var $c55f0f00c083b958$var$onError = function onError(reject) {
    return function() {
        reject(new Error("Failed to load Stripe.js"));
    };
};
var $c55f0f00c083b958$var$onLoad = function onLoad(resolve, reject) {
    return function() {
        if (window.Stripe) resolve(window.Stripe);
        else reject(new Error("Stripe.js not available"));
    };
};
var $c55f0f00c083b958$var$loadScript = function loadScript(params) {
    // Ensure that we only attempt to load Stripe.js at most once
    if ($c55f0f00c083b958$var$stripePromise !== null) return $c55f0f00c083b958$var$stripePromise;
    $c55f0f00c083b958$var$stripePromise = new Promise(function(resolve, reject) {
        if (typeof window === "undefined" || typeof document === "undefined") {
            // Resolve to null when imported server side. This makes the module
            // safe to import in an isomorphic code base.
            resolve(null);
            return;
        }
        if (window.Stripe && params) console.warn($c55f0f00c083b958$var$EXISTING_SCRIPT_MESSAGE);
        if (window.Stripe) {
            resolve(window.Stripe);
            return;
        }
        try {
            var script = $c55f0f00c083b958$var$findScript();
            if (script && params) console.warn($c55f0f00c083b958$var$EXISTING_SCRIPT_MESSAGE);
            else if (!script) script = $c55f0f00c083b958$var$injectScript(params);
            else if (script && $c55f0f00c083b958$var$onLoadListener !== null && $c55f0f00c083b958$var$onErrorListener !== null) {
                var _script$parentNode;
                // remove event listeners
                script.removeEventListener("load", $c55f0f00c083b958$var$onLoadListener);
                script.removeEventListener("error", $c55f0f00c083b958$var$onErrorListener); // if script exists, but we are reloading due to an error,
                // reload script to trigger 'load' event
                (_script$parentNode = script.parentNode) === null || _script$parentNode === void 0 || _script$parentNode.removeChild(script);
                script = $c55f0f00c083b958$var$injectScript(params);
            }
            $c55f0f00c083b958$var$onLoadListener = $c55f0f00c083b958$var$onLoad(resolve, reject);
            $c55f0f00c083b958$var$onErrorListener = $c55f0f00c083b958$var$onError(reject);
            script.addEventListener("load", $c55f0f00c083b958$var$onLoadListener);
            script.addEventListener("error", $c55f0f00c083b958$var$onErrorListener);
        } catch (error) {
            reject(error);
            return;
        }
    }); // Resets stripePromise on error
    return $c55f0f00c083b958$var$stripePromise["catch"](function(error) {
        $c55f0f00c083b958$var$stripePromise = null;
        return Promise.reject(error);
    });
};
var $c55f0f00c083b958$var$initStripe = function initStripe(maybeStripe, args, startTime) {
    if (maybeStripe === null) return null;
    var stripe = maybeStripe.apply(undefined, args);
    $c55f0f00c083b958$var$registerWrapper(stripe, startTime);
    return stripe;
}; // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
var $c55f0f00c083b958$var$stripePromise$1;
var $c55f0f00c083b958$var$loadCalled = false;
var $c55f0f00c083b958$var$getStripePromise = function getStripePromise() {
    if ($c55f0f00c083b958$var$stripePromise$1) return $c55f0f00c083b958$var$stripePromise$1;
    $c55f0f00c083b958$var$stripePromise$1 = $c55f0f00c083b958$var$loadScript(null)["catch"](function(error) {
        // clear cache on error
        $c55f0f00c083b958$var$stripePromise$1 = null;
        return Promise.reject(error);
    });
    return $c55f0f00c083b958$var$stripePromise$1;
}; // Execute our own script injection after a tick to give users time to do their
// own script injection.
Promise.resolve().then(function() {
    return $c55f0f00c083b958$var$getStripePromise();
})["catch"](function(error) {
    if (!$c55f0f00c083b958$var$loadCalled) console.warn(error);
});
var $c55f0f00c083b958$export$de80f7562c3fd6b1 = function loadStripe() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $c55f0f00c083b958$var$loadCalled = true;
    var startTime = Date.now(); // if previous attempts are unsuccessful, will re-load script
    return $c55f0f00c083b958$var$getStripePromise().then(function(maybeStripe) {
        return $c55f0f00c083b958$var$initStripe(maybeStripe, args, startTime);
    });
};

});


//

var $1hMmA = parcelRequire("1hMmA");
parcelRequire("dlJNO");
var $7Hbcq = parcelRequire("7Hbcq");
const $d6926edd20ff1868$var$DEV_MODE = window.location.hostname === "localhost";
const $d6926edd20ff1868$var$STRIPE_PUBLISHABLE_KEY = $d6926edd20ff1868$var$DEV_MODE ? "pk_test_hBg7VUKMGsCU9oSuqhXteEAs" : "pk_live_Vipcv6OkbBX6jyjuNorz3qTy";
const $d6926edd20ff1868$var$FSPACE_API_URL = $d6926edd20ff1868$var$DEV_MODE ? "http://localhost:57975" : "https://api.fspace.me";
function $d6926edd20ff1868$var$setCookie(name, value, days) {
    let expires = "";
    if (days !== undefined) {
        const date = new Date();
        if (days === 0) // Session cookie: no expiration date set
        expires = "";
        else if (days === null) {
            // End of current day: set expiration to midnight
            date.setHours(23, 59, 59, 999);
            expires = "; expires=" + date.toUTCString();
        } else {
            // Days-based expiration: expire after specified number of days
            date.setTime(date.getTime() + days * 86400000);
            expires = "; expires=" + date.toUTCString();
        }
    }
    document.cookie = `${name}=${encodeURIComponent(value) || ""}${expires}; path=/`;
}
function $d6926edd20ff1868$var$getCookie(name) {
    const nameEQ = name + "=";
    const cookies = document.cookie.split(";");
    for(let i = 0; i < cookies.length; i++){
        let cookie = cookies[i].trim();
        if (cookie.indexOf(nameEQ) === 0) return decodeURIComponent(cookie.substring(nameEQ.length));
    }
    return null;
}
function $d6926edd20ff1868$var$deleteCookie(name) {
    $d6926edd20ff1868$var$setCookie(name, "", -1); // Expiration time in the past
}
function $d6926edd20ff1868$var$showError(error) {
    (0, (/*@__PURE__*/$parcel$interopDefault($1hMmA))).modal(document.getElementById("error-modal")).show();
    console.error("There has been a problem with your fetch operation:", error);
    return false;
}
function $d6926edd20ff1868$var$_paint(replacements) {
    const keys = Object.keys(replacements);
    for(let i = 0; i < keys.length; i++){
        const key = keys[i];
        const elements = document.querySelectorAll("*[" + key + "]");
        for(let j = 0; j < elements.length; j++)if (elements[j].getAttribute(key)) elements[j][elements[j].getAttribute(key)] = replacements[key]();
        else elements[j].innerHTML = replacements[key]();
    }
}
function $d6926edd20ff1868$var$paint(plan, initial = false) {
    const replacements_initial = {
        "f-plan-name": function() {
            return plan.name;
        },
        "f-plan-price": function() {
            plan._price = Math.round(plan.price_per_cycle_in_cents * 1.1) / 100;
            return plan._price;
        },
        "f-plan-synopsis": function() {
            return plan.description.split("\r\n").at(0);
        },
        "f-plan-features": function() {
            return plan.description.split("\r\n").filter(function(text, i) {
                return i && text;
            }).map(function(text, i) {
                return '<li><span uk-icon="check"></span> ' + text.replace("\xb7 ", "") + "</li>";
            }).join("");
        },
        "f-plan-extras": function() {
            let html = "";
            plan._fields = {};
            for(let x = 0; x < plan.extras.length; x++){
                const extra = {
                    internal_id: plan.extras[x].id,
                    name: plan.extras[x].name,
                    price: Math.round(plan.extras[x].price_in_cents * 1.1) / 100
                };
                switch(plan.extras[x].name){
                    case "24x7 Access":
                        plan._fields.extras_access = extra;
                        html += '<h4>Access</h4>\n<div class="input-radio">\n  <input type="radio" id="extra_access_default" name="extras_access" value="" checked>\n  <label for="extra_access_default">\n    <strong>Weekdays, 8 am to 6 pm, excluding public holidays</strong>\n    <span></span>\n  </label>\n</div>\n<div class="input-radio">\n  <input type="radio" id="extra_access_24x7" name="extras_access" value="' + extra.internal_id + '">\n' + '  <label for="extra_access_24x7">\n' + "    <strong>24x7, all year round</strong>\n" + "    <span>+ $" + extra.price + " / month</span>\n" + "  </label>\n" + "</div>\n";
                        break;
                    case "Locker":
                        plan._fields.extras_locker = extra;
                        html += '<h4>Locker</h4>\n<div class="input-radio">\n  <input type="radio" id="extra_locker_default" name="extras_locker" value="" checked>\n  <label for="extra_locker_default">\n    <strong>No locker</strong>\n    <span></span>\n  </label>\n</div>\n<div class="input-radio">\n  <input type="radio" id="extra_locker_addon" name="extras_locker" value="' + extra.internal_id + '">\n' + '  <label for="extra_locker_addon">\n' + "    <strong>Locker with key</strong>\n" + "    <span>+ $" + extra.price + " / month</span>\n" + "  </label>\n" + "</div>\n";
                        break;
                    case "Monitor Storage (for BYO)":
                        plan._fields.extras_monitorstorage = extra;
                        html += '<h4>Monitors</h4>\n<div class="input-radio">\n  <input type="radio" id="extra_monitorstorage_default" name="extras_monitorstorage" value="" checked>\n  <label for="extra_monitorstorage_default">\n    <strong>Book ours, from $1/day</strong>\n    <span></span>\n  </label>\n</div>\n<div class="input-radio">\n  <input type="radio" id="extra_monitorstorage_addon" name="extras_monitorstorage" value="' + extra.internal_id + '">\n' + '  <label for="extra_monitorstorage_addon">\n' + "    <strong>Storage for BYO</strong>\n" + "    <span>+ $" + extra.price + " / month</span>\n" + "  </label>\n" + "</div>\n";
                        break;
                    case "Shared Monitor":
                        plan._fields.extras_sharedmonitor = extra;
                        html += '<h4>Monitors</h4>\n<div class="input-radio">\n  <input type="radio" id="extra_sharedmonitor_default" name="extras_sharedmonitor" value="" checked>\n  <label for="extra_sharedmonitor_default">\n    <strong>No monitors</strong>\n    <span></span>\n  </label>\n</div>\n<div class="input-radio">\n  <input type="radio" id="extra_sharedmonitor_addon" name="extras_sharedmonitor" value="' + extra.internal_id + '">\n' + '  <label for="extra_sharedmonitor_addon">\n' + "    <strong>Access to shared monitors. Put away after use.</strong>\n" + "    <span>+ $" + extra.price + " / month</span>\n" + "  </label>\n" + "</div>\n";
                        break;
                    case "Sit/Stand Desk":
                        plan._fields.extras_desk = extra;
                        html += '<h4>Desk</h4>\n<div class="input-radio">\n  <input type="radio" id="extra_desk_default" name="extras_desk" value="" checked>\n  <label for="extra_desk_default">\n    <strong>Regular</strong>\n    <span></span>\n  </label>\n</div>\n<div class="input-radio">\n  <input type="radio" id="extra_desk_addon" name="extras_desk" value="' + extra.internal_id + '">\n' + '  <label for="extra_desk_addon">\n' + "    <strong>Electric Sit / Stand</strong>\n" + "    <span>+ $" + extra.price + " / month</span>\n" + "  </label>\n" + "</div>\n";
                        break;
                    case "2x Monitors":
                        plan._fields.extras_2monitors = extra;
                        html += '<h4>Monitors</h4>\n<div class="input-radio">\n  <input type="radio" id="extras_2monitors_default" name="extras_2monitors" value="" checked>\n  <label for="extras_2monitors_default">\n    <strong>BYO or share included</strong>\n    <span></span>\n  </label>\n</div>\n<div class="input-radio">\n  <input type="radio" id="extras_2monitors_addon" name="extras_2monitors" value="' + extra.internal_id + '">\n' + '  <label for="extras_2monitors_addon">\n' + "    <strong>Two adjustable 27&quot; Dell monitors (USB-C &amp; HDMI)</strong>\n" + "    <span>+ $" + extra.price + " / month</span>\n" + "  </label>\n" + "</div>\n";
                        break;
                }
            }
            return html;
        }
    };
    const replacements = {
        "f-live-price": function() {
            let total_in_cents = plan._price * 100;
            const inputs = document.getElementById("join-form").elements;
            for(let i = 0; i < inputs.length; i++)if (inputs[i].nodeName === "INPUT" && inputs[i].name.substring(0, 7) === "extras_" && inputs[i].checked == true && inputs[i].value != "") {
                const field_settings = plan._fields[inputs[i].name];
                total_in_cents += field_settings.price * 100;
            }
            return total_in_cents / 100;
        },
        "f-review-table": function() {
            let total_in_cents = 0;
            let html = "<tbody>\n  <tr>\n    <td>" + plan.name + " Membership</td>\n" + "    <td>$" + plan._price + " AUD</td>\n" + "  </tr>\n";
            total_in_cents += plan._price * 100;
            const inputs = document.getElementById("join-form").elements;
            for(let i = 0; i < inputs.length; i++)if (inputs[i].nodeName === "INPUT" && inputs[i].name.substring(0, 7) === "extras_" && inputs[i].checked == true && inputs[i].value != "") {
                const field_settings = plan._fields[inputs[i].name];
                total_in_cents += field_settings.price * 100;
                html += "  <tr>\n    <td>+ " + field_settings.name + "</td>\n" + "    <td>$" + field_settings.price + " AUD</td>\n" + "  </tr>\n";
            }
            const gst = Math.round(total_in_cents * 0.090909) / 100;
            const total = total_in_cents / 100;
            html += '</tbody>\n<tfoot>\n  <tr class="gst">\n    <td>10% GST (included)</td>\n    <td>$' + gst + " AUD</td>\n" + "  </tr>\n" + '  <tr class="total">\n' + "    <td>Monthly Total</td>\n" + "    <td>$" + total + " AUD</td>\n" + "  </tr>\n" + "</tfoot>";
            return html;
        },
        "f-discount-section": function() {
            const discount = {
                code: document.getElementById("discount_code_hidden").value,
                percent: document.getElementById("discount_percent_hidden").value,
                terms: document.getElementById("discount_terms_hidden").value,
                description: document.getElementById("discount_description_hidden").value
            };
            if (discount.code === "") return "";
            const terms = discount.terms > 1 ? discount.terms + " months" : " month";
            const total = Math.round(plan._price * 100) / 100;
            const total_with_discount = Math.round(plan._price * (1 - discount.percent) * 100) / 100;
            const html_terms = discount.terms > 0 ? "for the first " + terms + ", then $" + total + " AUD per month" : "per month, excluding add-ons. Eligibility must be maintained.";
            const html = '<div class="show-discount"><h5>Offer Applied!</h5>' + discount.description + "<br>" + "You'll be charged $" + total_with_discount + " AUD " + html_terms + "</div>";
            return html;
        }
    };
    if (initial === true) $d6926edd20ff1868$var$_paint(replacements_initial);
    $d6926edd20ff1868$var$_paint(replacements);
}
function $d6926edd20ff1868$var$ordinalSuffix(number) {
    const last_two_digits = Number(number.substring(-2));
    if (last_two_digits > 3 && last_two_digits < 21) return "th";
    switch(last_two_digits % 10){
        case 1:
            return "st";
        case 2:
            return "nd";
        case 3:
            return "rd";
        default:
            return "th";
    }
}
// Returns the ISO week of the date.
Date.prototype.getWeek = function() {
    var date = new Date(this.getTime());
    date.setHours(0, 0, 0, 0);
    // Thursday in current week decides the year.
    date.setDate(date.getDate() + 3 - (date.getDay() + 6) % 7);
    // January 4 is always in week 1.
    var week1 = new Date(date.getFullYear(), 0, 4);
    // Adjust to Thursday in week 1 and count number of weeks from date to week1.
    return 1 + Math.round(((date.getTime() - week1.getTime()) / 86400000 - 3 + (week1.getDay() + 6) % 7) / 7);
};
Date.prototype.getMonday = function() {
    let day = this.getDay(), diff = this.getDate() - day + (day == 0 ? -6 : 1);
    return new Date(this.setDate(diff));
};
Date.prototype.getSunday = function() {
    let day = this.getDay(), diff = this.getDate() + (day == 0 ? 0 : 7 - day);
    return new Date(this.setDate(diff));
};
Date.prototype.addWeek = function() {
    let new_date = new Date(this);
    new_date.setDate(this.getDate() + 7);
    return new_date;
};
Date.prototype.addMonth = function() {
    let new_date = new Date(this);
    new_date.setMonth(this.getMonth() + 1);
    return new_date;
};
function $d6926edd20ff1868$var$populateWeeks(date, weeks, i = 0) {
    weeks.push({
        week_number: date.getWeek(),
        start: date.getMonday(),
        end: date.getSunday()
    });
    if (i < 4) weeks = $d6926edd20ff1868$var$populateWeeks(date.addWeek(), weeks, i + 1);
    return weeks;
}
function $d6926edd20ff1868$var$setBooking(stamp) {
    const date = new Date(stamp);
    document.getElementById("appointment-date").innerHTML = [
        date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            weekday: "long"
        }),
        ", ",
        date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            month: "long"
        }),
        " ",
        date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            day: "numeric"
        }),
        $d6926edd20ff1868$var$ordinalSuffix(date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            day: "numeric"
        }))
    ].join("");
    document.getElementById("appointment-time").innerHTML = [
        date.toLocaleTimeString("en-AU", {
            timeZone: "Australia/Perth",
            hour12: true,
            hour: "numeric"
        })
    ].join("");
    let html = "";
    html += "Welcome Tour: " + [
        date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            month: "long"
        }),
        " ",
        date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            day: "numeric"
        }),
        $d6926edd20ff1868$var$ordinalSuffix(date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            day: "numeric"
        })),
        ", ",
        date.toLocaleTimeString("en-AU", {
            timeZone: "Australia/Perth",
            hour12: true,
            hour: "numeric"
        })
    ].join("") + "<br>";
    html += "Membership Starts: " + [
        date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            month: "long"
        }),
        " ",
        date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            day: "numeric"
        }),
        $d6926edd20ff1868$var$ordinalSuffix(date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            day: "numeric"
        })),
        " ",
        date.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            year: "numeric"
        })
    ].join("") + "<br>";
    const renewDate = date.addMonth();
    html += "Membership Renews: " + [
        renewDate.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            month: "long"
        }),
        " ",
        renewDate.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            day: "numeric"
        }),
        $d6926edd20ff1868$var$ordinalSuffix(renewDate.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            day: "numeric"
        })),
        " ",
        renewDate.toLocaleDateString("en-AU", {
            timeZone: "Australia/Perth",
            year: "numeric"
        })
    ].join("") + "<br>";
    document.querySelector("*[f-review-dates]").innerHTML = html;
    document.querySelector("*[f-booking-stamp]").value = stamp;
}
function $d6926edd20ff1868$var$paintAvailability(slots) {
    let tree = {};
    let default_stamp;
    const weeks = $d6926edd20ff1868$var$populateWeeks(new Date(), []);
    for(let i = 0; i < slots.length; i++){
        const stamp = slots[i];
        const stamp_date = stamp.substring(0, 10);
        const date = new Date(slots[i]);
        if (typeof tree[stamp_date] == "undefined") tree[stamp_date] = {
            date: date,
            parts: {
                weekday: date.toLocaleDateString("en-AU", {
                    timeZone: "Australia/Perth",
                    weekday: "long"
                }),
                day: date.toLocaleDateString("en-AU", {
                    timeZone: "Australia/Perth",
                    day: "numeric"
                }),
                suffix: $d6926edd20ff1868$var$ordinalSuffix(date.toLocaleDateString("en-AU", {
                    timeZone: "Australia/Perth",
                    day: "numeric"
                })),
                month: date.toLocaleDateString("en-AU", {
                    timeZone: "Australia/Perth",
                    month: "long"
                }),
                year: date.toLocaleDateString("en-AU", {
                    timeZone: "Australia/Perth",
                    year: "numeric"
                })
            },
            times: []
        };
        tree[stamp_date].times.push({
            stamp: stamp,
            label: date.toLocaleTimeString("en-AU", {
                timeZone: "Australia/Perth",
                hour12: true,
                hour: "numeric"
            })
        });
        if (i === 0) default_stamp = stamp;
    }
    const keys = Object.keys(tree);
    let html = "";
    for(let j = 0; j < weeks.length; j++){
        const week = weeks[j];
        const week_label = function() {
            switch(j){
                case 0:
                    return "This Week";
                case 1:
                    return "Next Week";
                default:
                    return [
                        week.start.toLocaleDateString("en-AU", {
                            timeZone: "Australia/Perth",
                            month: "long"
                        }),
                        " ",
                        week.start.toLocaleDateString("en-AU", {
                            timeZone: "Australia/Perth",
                            day: "numeric"
                        }),
                        $d6926edd20ff1868$var$ordinalSuffix(week.start.toLocaleDateString("en-AU", {
                            timeZone: "Australia/Perth",
                            day: "numeric"
                        })),
                        " - ",
                        week.end.toLocaleDateString("en-AU", {
                            timeZone: "Australia/Perth",
                            month: "long"
                        }),
                        " ",
                        week.end.toLocaleDateString("en-AU", {
                            timeZone: "Australia/Perth",
                            day: "numeric"
                        }),
                        $d6926edd20ff1868$var$ordinalSuffix(week.end.toLocaleDateString("en-AU", {
                            timeZone: "Australia/Perth",
                            day: "numeric"
                        }))
                    ].join("");
            }
        }();
        html += '<div class="appointment-week">\n<div class="legend">' + week_label + "</div>\n";
        for(let k = 0; k < keys.length; k++){
            const subtree = tree[keys[k]];
            if (subtree.date.getWeek() === week.week_number) {
                html += '  <div class="appointment-day">\n    <div class="legend">        <span class="dayname">' + subtree.parts.weekday + "</span>" + "        " + subtree.parts.month.toUpperCase() + "        " + subtree.parts.day.toUpperCase() + subtree.parts.suffix + "," + "        " + subtree.parts.year + "    </div>\n";
                for(let l = 0; l < subtree.times.length; l++){
                    const selected = k + l === 0 ? "selected" : "";
                    const time = subtree.times[l];
                    html += '    <div class="appointment-slot ' + selected + '" timestamp="' + time.stamp + '">' + time.label + "</div>\n";
                }
                html += "  </div>\n";
            }
        }
        html += "</div>";
    }
    $d6926edd20ff1868$var$setBooking(default_stamp);
    document.querySelector("*[f-availability]").innerHTML = html;
    let selected_stamp = default_stamp;
    document.getElementById("booking-save").addEventListener("click", function() {
        $d6926edd20ff1868$var$setBooking(selected_stamp);
        (0, (/*@__PURE__*/$parcel$interopDefault($1hMmA))).modal("#join-appointment-selector").hide();
    });
    const appointmentSelectors = document.getElementsByClassName("appointment-selector");
    for(let i = 0; i < appointmentSelectors.length; i++){
        const appointmentSelector = appointmentSelectors[i];
        const body = appointmentSelector.querySelector(".appointment-selector-body");
        const scrollers = appointmentSelector.getElementsByClassName("appointment-scroll-down");
        for(let j = 0; j < scrollers.length; j++){
            const scroller = scrollers[j];
            scroller.addEventListener("click", function(evt) {
                evt.stopPropagation();
                evt.preventDefault();
                body.scrollTop += 25;
            });
        }
        const slots = appointmentSelector.getElementsByClassName("appointment-slot");
        for(let k = 0; k < slots.length; k++){
            const slot = slots[k];
            slot.addEventListener("click", function(evt) {
                for(let l = 0; l < slots.length; l++)slots[l].classList.remove("selected");
                slot.classList.add("selected");
                selected_stamp = slot.attributes["timestamp"].value;
            });
        }
    }
}
NodeList.prototype.setDisabled = function(disable = true) {
    for(let i = 0; i < this.length; i++)switch(this.item(i).nodeName){
        case "INPUT":
        case "BUTTON":
            this.item(i).disabled = disable ? "disabled" : "";
            break;
        default:
            if (disable) this.item(i).setAttribute("disabled", "disabled");
            else this.item(i).removeAttribute("disabled");
            break;
    }
    return this;
};
function $d6926edd20ff1868$var$showStripeMessage(messageText) {
    const messageContainer = document.querySelector("#payment-message");
    messageContainer.classList.remove("uk-hidden");
    messageContainer.textContent = messageText;
    setTimeout(function() {
        messageContainer.classList.add("uk-hidden");
        messageContainer.textContent = "";
    }, 4000);
}
function $d6926edd20ff1868$var$applyDiscountCode(discount_code) {
    const REA_discount = {
        percent: 0.35,
        terms: 3,
        description: "35% off for the first 3 months"
    };
    const lookup_table = {
        "DAY1.35%": {
            percent: 0.35,
            terms: 1,
            description: "35% off for the first month"
        },
        "WEEK1.20%": {
            percent: 0.20,
            terms: 1,
            description: "20% off for the first month"
        },
        "WAGIC": {
            percent: 0.20,
            terms: 0,
            description: "20% off for current WAGIC members"
        },
        "RW35": REA_discount,
        "CY35": REA_discount,
        "FC35": REA_discount,
        "WH35": REA_discount,
        "WELCOME35": REA_discount
    };
    if (typeof lookup_table[discount_code] === "undefined") throw new Error("Invalid promotion code");
    const config = lookup_table[discount_code];
    document.getElementById("discount_code_hidden").value = discount_code;
    document.getElementById("discount_percent_hidden").value = config.percent;
    document.getElementById("discount_terms_hidden").value = config.terms;
    document.getElementById("discount_description_hidden").value = config.description;
    $d6926edd20ff1868$var$setCookie("discount_code", discount_code);
    document.getElementById("join-form").dispatchEvent(new Event("change"));
// alert(config.description);
}
async function $d6926edd20ff1868$var$main() {
    try {
        let elements;
        let stripe;
        // const stripe = new Stripe('sk_test_QvR9zYHwIdYt0VK33ojEhPxS');
        (0, $7Hbcq.loadStripe)($d6926edd20ff1868$var$STRIPE_PUBLISHABLE_KEY).then(async function(_stripe) {
            stripe = _stripe;
            const response = await fetch($d6926edd20ff1868$var$FSPACE_API_URL + "/stripe/setup", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json"
                },
                body: JSON.stringify({})
            });
            const { clientSecret: clientSecret } = await response.json();
            elements = stripe.elements({
                clientSecret: clientSecret,
                appearance: {
                    theme: "stripe"
                }
            });
            const paymentElement = elements.create("payment", {
                layout: "tabs"
            });
            let val = paymentElement.mount("#payment-element");
        }).catch(function(evt) {
            console.log(evt);
        });
        const form = document.querySelector("#join-form");
        form.addEventListener("submit", async function(evt) {
            evt.preventDefault();
            evt.stopPropagation();
            const formData = new FormData(form);
            const values = Object.fromEntries(formData);
            const url = new URL($d6926edd20ff1868$var$FSPACE_API_URL + "/checkout");
            url.searchParams.set("plan_id", plan.id);
            url.searchParams.set("name", values.name);
            url.searchParams.set("company", values.company);
            url.searchParams.set("phone", values.phone);
            url.searchParams.set("email", values.email);
            url.searchParams.set("booking", values.booking);
            url.searchParams.set("agree_terms", values.agree_terms);
            url.searchParams.set("agree_ontime", values.agree_ontime);
            url.searchParams.set("agree_price", values.agree_price);
            url.searchParams.set("discount_code", values.discount_code);
            url.searchParams.set("discount_terms", values.discount_terms);
            url.searchParams.set("discount_percent", values.discount_percent);
            const extraIDs = [];
            const extraKeys = Object.keys(values);
            for(let i = 0; i < extraKeys.length; i++){
                const key = extraKeys[i];
                if (key.substring(0, 7) === "extras_") extraIDs.push(values[key]);
            }
            url.searchParams.set("extras", extraIDs.join(","));
            const inputs = form.querySelectorAll("input,button,a,#payment-element");
            inputs.setDisabled(true);
            const { error: error } = await stripe.confirmSetup({
                elements: elements,
                confirmParams: {
                    // Return URL where the customer should be redirected after the SetupIntent is confirmed.
                    return_url: url.toString()
                }
            });
            if (error) {
                // Inform the customer that there was an error.
                // showStripeMessage(error.message);
                let error_message = "There's been an error processing your payment.\n\nError type: " + error.type + "\n";
                if (error.message.length > 0) error_message += "Error message: " + error.message;
                alert(error_message);
                inputs.setDisabled(false);
            }
        });
        const urlParams = new URLSearchParams(window.location.search);
        const plan_name = urlParams.get("plan");
        fetch($d6926edd20ff1868$var$FSPACE_API_URL + "/bookings/availability", {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        }).then(function(response) {
            if (!response.ok) return $d6926edd20ff1868$var$showError("Booking system error #1");
            response.json().then(function(json) {
                $d6926edd20ff1868$var$paintAvailability(json);
            }).catch(function(e) {
                return $d6926edd20ff1868$var$showError("Booking system error #2");
            });
        }).catch(function(e) {
            return $d6926edd20ff1868$var$showError("Booking system error #3");
        });
        const response = await fetch($d6926edd20ff1868$var$FSPACE_API_URL + "/plans", {
            method: "GET",
            headers: {
                "Content-Type": "application/json"
            }
        });
        if (!response.ok) return showerror("Network response was not OK");
        const plans = await response.json();
        const plan = plans.filter(function(plan, i) {
            return plan.name.toLowerCase() === plan_name;
        }).at(0);
        $d6926edd20ff1868$var$paint(plan, true);
        document.getElementById("join-form").addEventListener("change", function(evt) {
            $d6926edd20ff1868$var$paint(plan);
        });
        document.getElementById("promotion-apply").addEventListener("click", function(evt) {
            try {
                $d6926edd20ff1868$var$applyDiscountCode(document.getElementById("form-promotion-code").value.toUpperCase());
            } catch (error) {
                alert(error);
                return;
            }
            (0, (/*@__PURE__*/$parcel$interopDefault($1hMmA))).modal("#promotion-form-modal").hide();
        });
        try {
            $d6926edd20ff1868$var$applyDiscountCode($d6926edd20ff1868$var$getCookie("discount_code"));
        } catch (error) {
        // fail silently
        }
        document.getElementById("join-loading").style.display = "none";
        const cards = document.getElementsByClassName("uk-card");
        for(let k = 0; k < cards.length; k++){
            cards[k].style.transition = "opacity 0.25s ease-in";
            cards[k].style.opacity = "1";
        }
    } catch (error) {
        $d6926edd20ff1868$var$showError(error);
    }
}
window.addEventListener("unload", function(e) {
    window.scrollTo(0, 0);
});
$d6926edd20ff1868$var$main();

})();
//# sourceMappingURL=join.4eb4bc02.js.map
